import request from "../request/request";

// 预警推送总览
export function warningStatistics(data) {
  return request({
    url: "/warningStatistics/characteristic",
    method: "post",
    data,
  });
}

// 分来源推送情况
export function warningSource(data) {
  return request({
    url: "/warningStatistics/source",
    method: "post",
    data,
  });
}
// 分方案推送情况
export function warningScheme(data) {
  return request({
    url: "/warningStatistics/topic",
    method: "post",
    data,
  });
}
// 重点舆情top10
export function warningTop10(data) {
  return request({
    url: "/warningStatistics/keyPublicOpinion",
    method: "post",
    data,
  });
}
//舆情展示分页
export function warningPage(data) {
  return request({
    url: "/warningStatistics/page",
    method: "post",
    data,
  });
}
//查询相似文章数
export function similarArticle(data) {
  return request({
    url: "/warningStatistics/acquaintance",
    method: "get",
    params: data,
  });
}
//获取行业标签
export function industryLabel(data) {
  return request({
    url: "/api/report/tag",
    method: "get",
    params: data,
  });
}
//查询每日热点
export function hotNews(data) {
  return request({
    url: "/api/report/page",
    method: "get",
    params: data,
  });
}
//获取来源
export function getSource(data) {
  return request({
    url: "/warningStatistics/sourceClassify",
    method: "get",
    params: data,
  });
}
//获取文章详情
export function getArticleDetail(data) {
  return request({
    url: "/verification/speechInfo",
    method: "get",
    params: data,
  });
}

//获取pdf文件流
export function getPdf(data) {
  return request({
    url: "/api/report/pdf",
    method: "get",
    params: data,
    responseType: "arraybuffer",
  });
}
//获取openid
export function getOpenid(data) {
  return request({
    url: "/verification/openid",
    method: "get",
    params: data,
  });
}
// 验证是否注册
export function checkRegister(data) {
  return request({
    url: "/api/wechatDocument/whetherRegister",
    method: "get",
    params: data,
  });
}
// 获取pdf预览文件
export function getPdfPreview(data) {
  return request({
    url: "/api/wechatDocument/pdf/byte",
    method: "get",
    params: data,
    responseType: "arraybuffer",
  });
}
//上传图片
export function uploaderFile(data) {
  return request({
    url: "/api/wechatDocument/upload/wechat",
    method: "post",
    data,
  });
}
// 用户注册;
export function userRegister(data) {
  return request({
    url: "/api/wechatDocument/register",
    method: "post",
    data,
  });
}
// 演示用户注册
export function register(data) {
  return request({
    url: "/api/wechatUser",
    method: "post",
    data,
  });
}
// 演示用户登录
export function loginUser(data) {
  return request({
    url: "/api/wechatUser/login/wechatUser",
    method: "post",
    data,
  });
}
// 登录成功发送消息
export function sendLoginSuccess(data) {
  return request({
    url: "/api/wechatUser/sendLoginSuccess",
    method: "get",
    params: data,
  });
}
// 获取微信卡片内容
export function getWechatCardContent(data) {
  return request({
    url: "/api/keyPersonnelRecognitionCard/details",
    method: "get",
    params: data,
  });
}
// 获取id

export function getId(data) {
  return request({
    url: "/api/wechatUserIp",
    method: "post",
    data,
  });
}
